import request from '../request';

import { PostUser, ResponseUser } from './types';

const postHostUser = async (user: PostUser) => {
  const createdUser = await request.post<ResponseUser>('/account/user/', user);
  return createdUser.data;
};

const postHostProfile = async (userId: number, HostId: number) => {
  await request.post('/account/host_profile/', {
    type: 'Ops',
    user: userId,
    host: HostId,
  });
};

export const handleRequestsCreateHostOpsModal = async (user: PostUser, hostId: number) => {
  try {
    const createdUser = await postHostUser(user);

    await postHostProfile(createdUser.id, hostId);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Erro ao criar usuário ou perfil Host Ops:', error);
    throw error;
  }
};
